import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

/**
 * Reusable confirmation dialog component.
 *
 * Props:
 * - open: boolean - whether the dialog is open
 * - title: string - dialog title
 * - message: string - confirmation message
 * - onConfirm: function - called when user confirms
 * - onCancel: function - called when user cancels or closes dialog
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
    >
      <DialogTitle id="confirm-dialog-title">{title || "Confirm"}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message || "Are you sure?"}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
